/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Parameters for event participant reminder job.

Sends reminders to participants before their scheduled events based on
event kind configuration. For each event kind with send_participant_reminder_hours_before
set, scans bookings starting within the configured time window (with 1h margin)
and sends styled email reminders with session details and Teams join link.
 */
export interface EventParticipantReminderParams {
  [key: string]: unknown;
}
